const authors = [
  {
    name: 'John Doe',
    imageUrl: 'python.png',
    bio:
      'John has been a front-end and UI designer fpr over 10 years, he is a brilliant artist',
    github: 'https://www.github.com/',
    google: 'https://www.google.com/',
    linkedin: 'https://www.linkedin.com/',
  },
]

module.exports = authors